import Vue from 'vue'

const Storage = {
  get(key) {
    return localStorage.getItem(key)
  },

  set(key, value) {
    localStorage.setItem(key, value)
  },

  has(key) {
    return !!localStorage.getItem(key)
  },

  destroy(key) {
    localStorage.removeItem(key)
  }
}

Vue.prototype.$storage = Storage

export default Storage
